import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '../../assets/icons/delete.svg';
import EditIcon from '../../assets/icons/green_edit.svg';
import ScreenLoader from '../../components/common/ScreenLoader';
import EditClassModal from '../../components/common/modals/classes/edit_class';
import DeletePermissionsModal from '../../components/common/modals/delete';
import { classesTableHeader } from '../../constants/appConstants';
import { setClassRooms } from '../../redux/slice/appSlice';
import { AuthenticatedGETRequest } from '../../utils';

const Classes = ({ createNotification }) => {
    const { classrooms } = useSelector((state) => state.appReducer);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [editDetails, setEditDetails] = useState(null);

    useEffect(() => {
        setLoading(true);
        const fetchClasses = async () => {
            try {
                const { data } = await AuthenticatedGETRequest('class_rooms');
                dispatch(setClassRooms(data));
                setLoading(false);
            } catch (error) {
                createNotification('error-toast', 'براہ کرم دوبارہ کوشش کریں۔');
                setLoading(false);
            }
        };
        fetchClasses();
        // eslint-disable-next-line
    }, [createNotification]);

    return loading ? (
        <ScreenLoader />
    ) : (
        <div className='flex column justifyCenter alignCenter w-100 content_area'>
            <div className='flex justifyCenter alignCenter w-100'>
                <h2>
                    کلاسز کی مجموعی تعداد :
                    <span
                        style={{
                            fontFamily: 'CircularStd',
                            fontSize: 26,
                            marginRight: 8,
                            color: '#2196f3',
                        }}
                    >
                        {classrooms.length}
                    </span>
                </h2>
            </div>

            <div className='flex column w-100'>
                <div className='flex justifyStart alignCenter table_header'>
                    {classesTableHeader.map((header, index) => (
                        <h3
                            key={index + 1}
                            className='table_header_element'
                            style={{
                                width: index === 0 ? 60 : 125,
                                textAlign:
                                    index === 0 || index === 1 || index === 2
                                        ? 'right'
                                        : index === 7
                                        ? 'left'
                                        : 'center',
                            }}
                        >
                            {header}
                        </h3>
                    ))}
                </div>

                <div className='flex column justifyStart alignCenter tabe_data_row'>
                    {classrooms.length > 0 &&
                        classrooms.map((classEntity, index) => (
                            <div
                                className='flex justifyStart alignCenter table_row'
                                key={index + 1}
                            >
                                <h4 style={{ width: 60, textAlign: 'right' }}>{index + 1}</h4>
                                <h3 style={{ width: 125, textAlign: 'right' }}>
                                    {classEntity.department_urdu_name}
                                </h3>
                                <h3 style={{ width: 125, textAlign: 'right' }}>
                                    {classEntity.name}
                                </h3>
                                <h3 style={{ width: 125 }}>{classEntity.section_count}</h3>
                                <h3 style={{ width: 125 }}>{classEntity.attendance_count}</h3>
                                <div
                                    className='flex justifyCenter alignCenter'
                                    onClick={() => {
                                        setEditDetails(classEntity);
                                        setEditModal(true);
                                    }}
                                    style={{ width: 125 }}
                                >
                                    <img src={EditIcon} alt='edit_icon' height={22} width={22} />
                                </div>
                                <div
                                    className='flex justifyCenter alignCenter'
                                    onClick={() => {
                                        setDeleteModal(true);
                                        setDeleteId(classEntity.id);
                                    }}
                                    style={{ width: 125 }}
                                >
                                    <img
                                        src={DeleteIcon}
                                        alt='delete_icon'
                                        height={32}
                                        width={32}
                                    />
                                </div>
                                <h3
                                    style={{
                                        width: 125,
                                        textAlign: 'left',
                                        fontSize: 14,
                                        fontFamily: 'CircularStd',
                                    }}
                                >
                                    {classEntity.english_name}
                                </h3>
                            </div>
                        ))}

                    {classrooms.length === 0 && (
                        <div className='flex justifyCenter alignCenter table_row'>
                            <h3>{`ایدمین کی طرف سے کوئی کلاسز کا کوئی ڈیٹا موصول نہیں ہوا۔`}</h3>
                        </div>
                    )}
                </div>
            </div>

            <DeletePermissionsModal
                label='کلاسز کا ریکارڈ حذف کریں'
                description='کیا آپ اس کلاس کے ریکارڈ کو مستقل طور پر حذف کرنے کا یقین رکھتے ہیں؟'
                btnText='حذف کریں'
                open={deleteModal}
                id={deleteId}
                screen='class_rooms'
                onClose={() => setDeleteModal(false)}
                onError={(error) => createNotification('error-toast', error)}
            />

            {editModal && editDetails && (
                <EditClassModal
                    data={editDetails}
                    open={editModal}
                    onClose={() => setEditModal(false)}
                    onError={(error) => createNotification('error-toast', error)}
                />
            )}
        </div>
    );
};

export default Classes;
